// ABOUTME: Adds the screen's dealership header to a header map, used by the Apollo `setContext` link.
// ABOUTME: Keeps GraphQL deterministic regardless of how the upload link binds fetch.

import { REQUEST_DEALERSHIP_HEADER } from '../constants';
import { getRequestDealership } from '../requestDealershipStore';

/**
 * Returns the headers with `x-dealership` added, or unchanged while no screen works in a
 * dealership. A dealership already set by the operation wins.
 */
export const withRequestDealershipHeader = <T extends Record<string, string> | undefined>(
    headers: T,
): T | Record<string, string> => {
    if (headers?.[REQUEST_DEALERSHIP_HEADER]) return headers;
    const dealership = getRequestDealership();
    return dealership ? { ...headers, [REQUEST_DEALERSHIP_HEADER]: dealership } : headers;
};
